import { render, staticRenderFns } from "./SolicitacaoAutorizacao.vue?vue&type=template&id=2b32235e&scoped=true&"
import script from "./SolicitacaoAutorizacao.vue?vue&type=script&lang=js&"
export * from "./SolicitacaoAutorizacao.vue?vue&type=script&lang=js&"
import style0 from "./SolicitacaoAutorizacao.vue?vue&type=style&index=0&id=2b32235e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b32235e",
  null
  
)

export default component.exports